import { Button, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import {
    Autocomplete,
    TextField
} from '@mui/material/';
import React, { useContext, useEffect, useState } from 'react';
import '../App.css';
import CorrelationGraph from './CorrelationGraph';
import PairPlot from "./PairPlotGraph";
import ScatterPlot from './ScatterPlot';
import ScatterPlot3D from './ScatterPlot3D';
import { SystemContext } from '../context';
import Modal from "@material-ui/core/Modal"

const MultiVariantAnalysisGraph = ({ fetchAPI }) => {

    const { fileName, numericalColumns, rawOrCleanData, stringColumns, allColumns, numericalCleanedCols, categoricalCleanedCols, allCleanedCols, actualFileName } = useContext(SystemContext);
    const [selectedColumnsData, setSelectedColumnsData] = useState([]);
    const [open, setOpen] = React.useState(false);

    const [featureOne, setFeatureOne] = useState('');
    const [featureTwo, setFeatureTwo] = useState('');
    const [featureThree, setFeatureThree] = useState('');
    const [featureFour, setFeatureFour] = useState('');
    const [multiGraphChoice, setMultiGraphChoice] = useState('scatter_plot');
    const [corelationValues, setCorelationvalues] = useState([]);
    const [corelationFlag, setCorelationFlag] = useState(false);
    const [colorScalingFeature, setColorScalingFeature] = useState('');
    const [pairPlotFlag, setPairPlotFlag] = useState(false);
    const [pairPlotValues, setPairPlotValues] = useState([]);
    const [pairPlotCategoricalFeature, setPairPlotCategoricalFeature] = useState("");
    const [showUniqueCombinations, setShowUniqueCombinations] = useState(true);
    const [loading, setLoading] = useState(false);


    useEffect(()=>{
        setFeatureOne('');
        setFeatureTwo('');
        setFeatureThree('');
        setFeatureFour('');
        setSelectedColumnsData([]);
        console.log("this is ",featureOne);
        console.log("this is ",featureTwo);
        console.log("this is ",featureThree);
        console.log("this is ",featureFour);
    },[rawOrCleanData])

    const handleFeatureOne = async (evt, value) => {
        setFeatureOne(value);
    }
    const handleFeatureTwo = async (evt, value) => {
        setFeatureTwo(value);
    }
    const handleFeatureThree = async (evt, value) => {
        setFeatureThree(value);
        setColorScalingFeature(value);
    }
    const handleFeatureFour = async (evt, value) => {
        setFeatureFour(value);
    }
    const handleCorelation = (evt, value) => {
        setCorelationvalues(value);
    }
    // const handlePairPlotValues = async (evt, value) => {
    //     setPairPlotValues(value);
    // };
    const handlePairPlotCategoricalFeature = async (evt, value) => {
        setPairPlotCategoricalFeature(value);
    };

    const handleSubmit = async (event) => {
        setLoading(true);
        let temp = [];
        if (featureOne && featureOne.length > 0) {
            temp.push(featureOne);
        }
        if (featureTwo && featureTwo.length > 0) {
            temp.push(featureTwo);
        }
        if (featureThree && featureThree.length > 0) {
            temp.push(featureThree);
        }
        if (featureFour && featureFour.length > 0) {
            temp.push(featureFour);
        }

        try {
            if (temp.length > 0 && featureOne && featureOne.length > 0 && featureTwo && featureTwo.length > 0) {
                const data_sys = {
                    "dtype": rawOrCleanData,
                    "filename": actualFileName,
                    "features": temp
                };

                try {
                    const response = await fetchAPI.post('/features', data_sys, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                        }
                    });

                    setSelectedColumnsData(response.data.data);
                } catch (error) {
                    console.error('Error uploading file:', error);
                }
            } else {
                alert("Feature one and Feature two are mandatory");
            }

        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);
            handleOpen();
        }
    }

    const handlePairPlotGraphSubmit = async () => {
        setLoading(true);
        try {
            const features = [...pairPlotValues, pairPlotCategoricalFeature];

            const data_sys = {
                dtype: rawOrCleanData,
                filename: actualFileName,
                features: features,
            };

            const response = await fetchAPI.post(
                "/features",
                data_sys,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                    }
                }
            );

            setSelectedColumnsData(response.data.data);
            setPairPlotFlag(true);
        } catch (error) {
            console.error("Error uploading file:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCorelationGraphSubmit = async () => {
        setLoading(true);
        try {
            const data_sys = {
                "dtype": rawOrCleanData,
                "filename": actualFileName,
                "features": corelationValues
            };
            const response = await fetchAPI.post('/features', data_sys, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
            setSelectedColumnsData(response.data.data);
            setCorelationFlag(true);
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            handleOpen();
            setLoading(false);
        }
    }

    const handleMultiVaraintGraphChoice = (event) => {
        if (event.target.value !== "corelation_heatmap") {
            setFeatureOne("");
            setFeatureTwo("");
            setFeatureThree("");
            setFeatureFour("");
        }
        setMultiGraphChoice(event.target.value);
    }

    const overlayStyle = {

        // width: '100%',
        // height: '100%',
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
        // zIndex: 1000,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        
    };

    const getFilteredOptions = (currentSelection) => {
        const selectedFeatures = [featureOne, featureTwo, featureThree, featureFour];
        return (rawOrCleanData === "clean" ? numericalCleanedCols : numericalColumns)
            .filter(option => !selectedFeatures.includes(option) || option === currentSelection);
    }
    const [limitPairPlotLabel, setLimitPairPlotLabel] = useState('');
    const handlePairPlotValues = (event, value) => {
        if (value.length <= 2) {
            setPairPlotValues(value)
            setLimitPairPlotLabel('')
        } else {
            setLimitPairPlotLabel("Currently Pair plot is limited to select only 2 features")
        }
    };
   

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <div > 
            <div style={{ display: 'flex', justifyContent: 'start', marginBottom: '1rem'}}>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    style={{ marginLeft: '1rem' }}
                    onChange={handleMultiVaraintGraphChoice}
                    value={multiGraphChoice}
                >
                    <FormControlLabel value="scatter_plot" control={<Radio />} label="Scatter Plot" />
                    {/* <FormControlLabel value="pair_plot" control={<Radio />} label="Pair Plot" /> */}
                    <FormControlLabel value="corelation_heatmap" control={<Radio />} label="Corelation Heat Map" />
                </RadioGroup>
            </div>
            {multiGraphChoice === "scatter_plot" ? (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'start', marginBottom: '1rem', color: '#152C73' }}>
                        <b>Scatter Plot</b>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Autocomplete
                            options={getFilteredOptions(featureOne)}
                            fullWidth
                            style={{ display: 'flex', marginBottom: '10px', width: '100%' }}
                            autoHighlight={true}
                            onChange={handleFeatureOne}
                            value={featureOne}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Feature 1" placeholder='Features' />
                            )}
                        />
                        <Autocomplete
                            options={getFilteredOptions(featureTwo)}
                            fullWidth
                            style={{ display: 'flex', marginBottom: '10px', width: '100%', marginLeft: '1rem' }}
                            autoHighlight={true}
                            onChange={handleFeatureTwo}
                            value={featureTwo}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Feature 2" placeholder='Features' />
                            )}
                        />
                        <Autocomplete
                            options={getFilteredOptions(featureThree)}
                            fullWidth
                            style={{ display: 'flex', marginBottom: '10px', width: '100%', marginLeft: '1rem' }}
                            autoHighlight={true}
                            onChange={handleFeatureThree}
                            value={featureThree}
                            renderInput={(params) => (
                                <TextField {...params} label="Color Scaling Feature" placeholder='Features' />
                            )}
                        />
                        <Autocomplete
                            options={getFilteredOptions(featureFour)}
                            fullWidth
                            style={{ display: 'flex', marginBottom: '10px', width: '100%', marginLeft: '1rem' }}
                            autoHighlight={true}
                            onChange={handleFeatureFour}
                            value={featureFour}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Feature 4" placeholder='Features' />
                            )}
                        />
                    </div>
                    <Modal
                        onClose={handleClose}
                        open={open}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <ScatterPlot data={selectedColumnsData} xKey={featureOne} yKey={featureTwo} colorKey={featureThree} zKey={featureFour} />
                            <ScatterPlot3D data={selectedColumnsData} xKey={featureOne} yKey={featureTwo} colorKey={featureThree} zKey={featureFour} />
                        </div>
                    </Modal>


                    <div style={{ display: 'flex', justifyContent: 'start', marginTop: '1rem', flexDirection: 'row' }}>
                        <Button
                            type="button"
                            style={{ top: "50%", left: "45%" }}
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                        >Plot Graph</Button>
                    </div>
                </div>
            ) : ""}
            {multiGraphChoice === "corelation_heatmap" ? (
                <div style={{ width: '100%' }} >
                    <div style={{ display: 'flex', justifyContent: 'start', marginBottom: '1rem', color: '#152C73' }}>
                        <b>Corelation Heat Map</b>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'start', marginBottom: '1rem' }}>
                        <Autocomplete
                            multiple
                            options={rawOrCleanData === "clean" ? numericalCleanedCols : numericalColumns}
                            fullWidth
                            style={{ display: 'flex', marginBottom: '10px', width: '50%', marginLeft: '1rem' }}
                            autoHighlight={true}
                            onChange={handleCorelation}
                            renderInput={(params) => (
                                <TextField {...params} label="Select feature for corelation" placeholder='Select feature for corelation' />
                            )}
                        />
                        <Button
                            type="button"
                            style={{ display: 'flex', marginLeft: '1rem', height: '50px' }}
                            variant="contained"
                            color="primary"
                            onClick={handleCorelationGraphSubmit}
                        >Plot Graph</Button>
                    </div>
                    {corelationFlag && <Modal
                        onClose={handleClose}
                        open={open}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <CorrelationGraph data={selectedColumnsData} />
                        </div>
                    </Modal>}
                </div>
            ) : ""}
            {multiGraphChoice === "pair_plot" ? (
                <div>
                    <div style={{ display: "flex", justifyContent: "start", marginBottom: "1rem", color: '#152C73' }}>
                        <b>Pair Plot</b>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "1rem" }}>
                        {/* <Autocomplete
                            multiple
                            options={rawOrCleanData === "clean" ? numericalCleanedCols : numericalColumns}
                            fullWidth
                            style={{ display: "flex", marginBottom: "10px", width: "60%", marginLeft: "1rem" }}
                            autoHighlight={true}
                            onChange={handlePairPlotValues}
                            renderInput={(params) => (
                                <TextField {...params} label="Select features for Pair Plot" placeholder="Select features" />
                            )}
                        /> */}
                        <Autocomplete
                            multiple
                            options={rawOrCleanData === "clean" ? numericalCleanedCols : numericalColumns}
                            value={pairPlotValues}
                            fullWidth
                            style={{ display: "flex", marginBottom: "10px", width: "60%", marginLeft: "1rem" }}
                            autoHighlight={true}
                            onChange={handlePairPlotValues}
                            renderInput={(params) => (
                                <TextField {...params} label="Select features for Pair Plot"
                                    placeholder="Select features" helperText={limitPairPlotLabel.length > 0 ? limitPairPlotLabel : ""} />
                            )}
                        />
                        <Autocomplete
                            options={rawOrCleanData === "clean" ? categoricalCleanedCols : stringColumns}
                            fullWidth
                            style={{ display: "flex", marginBottom: "10px", width: "30%" }}
                            autoHighlight={true}
                            onChange={handlePairPlotCategoricalFeature}
                            renderInput={(params) => (
                                <TextField {...params} label="Select categorical feature" placeholder="Choose a categorical feature" />
                            )}
                        />
                        <Button
                            type="button"
                            style={{ display: "flex", marginLeft: "1rem", height: "50px" }}
                            variant="contained"
                            color="primary"
                            onClick={handlePairPlotGraphSubmit}
                        >Plot Graph</Button>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginBottom: "1rem" }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={showUniqueCombinations}
                                onChange={() => setShowUniqueCombinations(!showUniqueCombinations)}
                            />
                            Show Unique Combinations Only
                        </label>
                    </div>
                    {pairPlotFlag && (
                        <div style={{ display: 'flex', justifyContent: 'start', marginBottom: '1rem', height: '1000px', width: '600px' }}>
                            <PairPlot
                                data={selectedColumnsData}
                                numcols={pairPlotValues}
                                categoricalColumn={pairPlotCategoricalFeature}
                                showUniqueCombinations={showUniqueCombinations}
                            />
                        </div>
                    )}
                </div>
            ) : ""}
            {loading && (
                <div style={overlayStyle}>
                    <div className="loader"></div>
                </div>
            )}
        </div>
    );
}

export default MultiVariantAnalysisGraph;
